import { ApiNetworkProvider } from "@multiversx/sdk-network-providers/out";
import { multiversxUrlApi } from "src/config";

export const networkProvider = new ApiNetworkProvider(multiversxUrlApi);